import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/app/[aroeven]/(bafad)/bafa-bafd/formations/[pathname]/_components/booking-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/app/[aroeven]/(bafad)/bafa-bafd/formations/[pathname]/_components/contact.tsx");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/general/logo-blanc.png");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/general/logo.png");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/calameo.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/facebook.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/instagram.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/snapchat.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/tiktok.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/whatsapp.svg");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/prod/web-dist/src/assets/img/rs/youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/consent/ConsentFooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/AOS.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoBackLink"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/GoBackLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/HeaderMobileMenuButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/MenuEntry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/layout/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collapse","CollapseLink"] */ "/home/tsagi/build/prod/web-dist/src/components/ui/Collapse.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/ui/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Lightbox"] */ "/home/tsagi/build/prod/web-dist/src/components/ui/Lightbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/ui/map/Map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/ui/Share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tsagi/build/prod/web-dist/src/components/ui/swiper/Swiper.tsx");
